export default __webpack_public_path__ + "static/media/svg.edb79335.svg";